var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaste(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6997 9H11.2999C10.7476 9 10.2999 9.44771 10.2999 10V21.0001C10.2999 21.5524 10.7476 22.0001 11.2999 22.0001H21C21.5523 22.0001 22 21.5524 22 21.0001V14.3H18.4497C17.4832 14.3 16.6997 13.5165 16.6997 12.55V9ZM12.25 19C12.25 18.5858 12.5858 18.25 13 18.25H19C19.4142 18.25 19.75 18.5858 19.75 19C19.75 19.4142 19.4142 19.75 19 19.75H13C12.5858 19.75 12.25 19.4142 12.25 19ZM13 15.25H17C17.4142 15.25 17.75 15.5858 17.75 16C17.75 16.4142 17.4142 16.75 17 16.75H13C12.5858 16.75 12.25 16.4142 12.25 16C12.25 15.5858 12.5858 15.25 13 15.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2768 12.8L18.1997 9.60889V12.55C18.1997 12.6881 18.3116 12.8 18.4497 12.8H21.2768Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 3C6 2.44772 6.44772 2 7 2H13C13.5523 2 14 2.44772 14 3V5C14 5.55228 13.5523 6 13 6H7C6.44772 6 6 5.55228 6 5V3Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 4H4C2.89543 4 2 4.89543 2 6V20C2 21.1046 2.89543 22 4 22H9.00791C8.87414 21.6938 8.79993 21.3556 8.79993 21.0001V10C8.79993 8.61929 9.91922 7.5 11.2999 7.5H7C5.61929 7.5 4.5 6.38071 4.5 5V4Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13 7.5H18V6C18 4.89543 17.1046 4 16 4H15.5V5C15.5 6.38071 14.3807 7.5 13 7.5Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6 4H14V5C14 5.55228 13.5523 6 13 6H7C6.44772 6 6 5.55228 6 5V4Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaste);
export default __webpack_public_path__ + "static/media/paste.b5188c425083e41ab33b53b0a9b624a8.svg";
export { ForwardRef as ReactComponent };